const personalInfoContent = [
  { meta: 'first name', metaInfo: 'Atta Ur Rahman' },
  { meta: 'last name', metaInfo: 'Farooqi' },
  { meta: 'Age', metaInfo: '25 Years' },
  { meta: 'Nationality', metaInfo: 'Pakistani' },
  { meta: 'Freelance', metaInfo: 'Available' },
  { meta: 'Address', metaInfo: 'Karachi, Pakistan' },
  { meta: 'phone', metaInfo: '+92 308 8092755' },
  { meta: 'whatsApp', metaInfo: '+92 319 2400141' },
  { meta: 'Email', metaInfo: 'attaurrahmanfarooqi9@gmail.com' },
  { meta: 'languages', metaInfo: 'Pashto, Urdu, English' },
];

const PersonalInfo = () => {
  return (
    <ul className="about-list list-unstyled open-sans-font">
      {personalInfoContent.map((val, i) => (
        <li key={i}>
          <span className="title">{val.meta}: </span>
          <span className="value d-block d-sm-inline-block d-lg-block d-xl-inline-block">
            {val.metaInfo}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default PersonalInfo;
